import { isZendeskEnabled } from '@gettactic/helpers/src/zendesk';

export const getHelperBubbleSpacing = () => {
  const hasBotBubble = isZendeskEnabled();

  return hasBotBubble ? 'md:mr-12' : '';
};
